export default __webpack_public_path__ + "static/media/userIcon.023380f8.svg";